module.exports = __webpack_public_path__ + "media/assets/site_images/field_sunrise_lazy-7dddd35c9ebf149aa32d43ee9098ce50.jpg";